export default __webpack_public_path__ + "static/media/logo_v3.48bc1586.png";